import axios from "axios";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND}/api`;

const client = axios.create({ baseURL: API });

client.interceptors.request.use((config) => {
  const token = localStorage.getItem("rs_admin_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const api = {
  // public
  getSettings: () => client.get("/settings").then((r) => r.data),
  submitEnquiry: (data) => client.post("/enquiries", data).then((r) => r.data),

  // admin
  adminLogin: (username, password) =>
    client.post("/admin/login", { username, password }).then((r) => r.data),
  adminMe: () => client.get("/admin/me").then((r) => r.data),
  adminStats: () => client.get("/admin/stats").then((r) => r.data),
  adminListEnquiries: () => client.get("/admin/enquiries").then((r) => r.data),
  adminUpdateEnquiry: (id, status) =>
    client.patch(`/admin/enquiries/${id}`, { status }).then((r) => r.data),
  adminDeleteEnquiry: (id) =>
    client.delete(`/admin/enquiries/${id}`).then((r) => r.data),
  adminUpdateSettings: (data) =>
    client.put("/admin/settings", data).then((r) => r.data),
};

export default api;
